import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { Spinner, Toast, ToastBody, ToastHeader } from "reactstrap";
import useAxios from "../../sections/useAxios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";


const MeetingsListing = () => {
  const { id } = useParams();
  const api = useAxios();
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const {
    data,
    isLoading: meetingsLoading,
    isError,
    error,
    refetch
  } = useQuery(
    ["company-meetings", id],
    async () => {
      const res = await api.get(`company/all-company-meetings/${id}`);
      return res.data;
    },
    { cacheTime: 0, enabled: !!id }
  );

  const company = data?.company ?? {};
  const meetings = data?.meetings ?? [];

  useEffect(() => {
    if (isError) {
      setToastMsg(error.message || "Something went wrong");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 4000);
    }
  }, [isError, error]);

  const columns = [
    { accessorKey: "id", header: "ID", size: 50 },
    {
      accessorKey: "name",
      header: "Meeting Slot",
      Cell: ({ row }) => (
        <span
          role="button"
          className="text-primary"
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(`/slot/${row.original.id}/meetings`)
          }
        >
          <u>{row.original.name}</u>
        </span>
      ),
    },
    { accessorKey: "start_time", header: "Start Time" },
    { accessorKey: "end_time", header: "End Time" },
    {
      accessorKey: "registration_count",
      header: "Registrations",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "is_blocked", header: "Status",

      Cell: ({ row }) => (
        <span
        >
          {row.original.is_blocked ?

            <span>Blocked&nbsp;<i class="fa-solid fa-ban me-2 text-center text-danger" style={{ width: "20px" }}></i></span>
            :

            <span>Open&nbsp;<i class="fa-solid fa-user-check me-2 text-center text-success" style={{ width: "20px" }}></i></span>

          }
        </span>
      ),

    },
    {
  header: "Block/Unblock",
  Cell: ({ row }) => {
    const isRowLoading =
      updateMutation.isLoading &&
      updateMutation.variables?.id === row.original.id;

    return (
      <span
        role="button"
        className="text-primary"
        style={{ cursor: "pointer" }}
        onClick={() =>
          updateMutation.mutate({
            id: row.original.id,
            is_blocked: !row?.original?.is_blocked,
          })
        }
      >
        {isRowLoading ? (
          <span>Processing...</span>
        ) : row?.original?.is_blocked ? (
          <i className="fa-solid fa-user-check me-2 text-center text-success" style={{ width: "20px" }}></i>
        ) : (
          <i className="fa-solid fa-ban me-2 text-center text-danger" style={{ width: "20px" }}></i>
        )}
      </span>
    );
  },
},
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    },
    {
      accessorKey: "updated_at",
      header: "Updated At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    },
  ];


  const updateMutation = useMutation(
    async (values) => {
      return api.patch(`company/update-meeting/${values.id}`, values);
    },
    {
      onSuccess: () => {
        toast.success(error?.response?.data?.message);
        refetch();
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    }
  );




  return (
    <div className="container my-4">

      <div className="card p-3 w-50 mb-3">
        <div className="d-flex align-items-center mb-3">
          <i class="fa-solid fa-building me-2 text-center primary-color" style={{ width: "20px" }}> </i> <h6 className="mb-0">{company?.name}</h6>
        </div>
        <div className="d-flex align-items-center mb-3">
          <i class="fa-solid fa-envelope me-2 text-center primary-color" style={{ width: "20px" }}> </i><h6 className="mb-0">{company?.email}</h6>
        </div>
        <div className="d-flex align-items-center">
          <i class="fa-solid fa-signs-post me-2 text-center primary-color" style={{ width: "20px" }}> </i> <h6 className="mb-0">{company?.location}</h6>
        </div>
      </div>

      <h4 className="primary-color fw-bold">Meetings for Company (ID: {id})</h4>

      {meetingsLoading && (
        <div className="d-flex justify-content-center align-items-center my-4">
          <Spinner color="primary" />
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 1050,
            minWidth: "250px",
          }}
        >
          <Toast isOpen={showToast}>
            <ToastHeader icon="danger">Error</ToastHeader>
            <ToastBody>{toastMsg}</ToastBody>
          </Toast>
        </div>
      )}

      {!meetingsLoading && !isError && (
        <MaterialReactTable
          columns={columns}
          data={meetings}
          muiTablePaperProps={{
            elevation: 10,
          }}
        />
      )}
    </div>
  );
};

export default MeetingsListing;
